import React, { useEffect } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useFormik } from "formik";
import { postData } from "actions";
import { CKEditor } from "ckeditor4-react";
import * as Yup from "yup";
import { API_URL_kbCategory } from "constants/api";
import { useDispatch } from "react-redux";
import { kbCategoryReducers } from "redux/kbCategorySlice";
import { useNavigate } from "react-router-dom";

const ModalAddCategory = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      status: 1,
      description: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
    }),
    onSubmit: (values) => {
      const formData = values;
      // Jika tidak ada item (dalam mode tambah), lakukan penambahan baru
      postData(
        API_URL_kbCategory,
        formData,
        { dispatch, redux: kbCategoryReducers },
        "ADD_KBCATEGORY",
        () => {
          callback();
        }
      );
      // Reset formik state
      formik.resetForm();

      // Tutup modal
      onClose();
    },
  });

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  useEffect(() => {
    // Reset formik state
    formik.resetForm();
  }, [onClose]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex justify-between">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Add Category
                        </Dialog.Title>
                        <button
                          type="button"
                          className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                          onClick={onClose}
                        >
                          X
                        </button>
                      </div>

                      <>
                        <div className="px-6 py-1">
                          <label htmlFor="link" className="block mb-1">
                            Name
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            className="w-full p-2 border border-gray-300 rounded-md"
                            value={formik.values.link}
                            onChange={formik.handleChange}
                          />
                          {formik.touched.name && formik.errors.name && (
                            <div className="text-red-500 dark:text-red-300 text-xs">
                              {formik.errors.name}
                            </div>
                          )}
                        </div>

                        <div className="px-6 py-1">
                          <label htmlFor="link" className="block mb-1">
                            Description
                          </label>
                          <CKEditor
                            config={toolbarConfig}
                            type="classic"
                            initData={formik.values.description}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "description",
                                e.editor.getData()
                              );
                            }}
                          />
                        </div>
                      </>
                    </div>
                  </div>
                  <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={onClose}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalAddCategory;
